import { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../lib/firebase";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const [email,setEmail] = useState("");
  const [password,setPassword] = useState("");
  const [err,setErr] = useState("");
  const nav = useNavigate();

  async function submit(e){
    e.preventDefault();
    setErr("");
    try {
      await signInWithEmailAndPassword(auth, email, password);
      nav("/admin");
    } catch (e) { setErr(e.message); }
  }

  return (
    <>
      {/* keeps bots from indexing even if someone finds it */}
      <meta name="robots" content="noindex" />
      <div className="mx-auto max-w-md px-4 sm:px-6 lg:px-8 py-24">
        <h1 className="text-3xl font-extrabold">Admin Login</h1>
        <form onSubmit={submit} className="mt-8 grid gap-4">
          <input className="rounded-lg border px-4 py-3" value={email} onChange={e=>setEmail(e.target.value)} placeholder="Email" type="email"/>
          <input className="rounded-lg border px-4 py-3" value={password} onChange={e=>setPassword(e.target.value)} placeholder="Password" type="password"/>
          {err && <p className="text-sm text-red-600">{err}</p>}
          <button className="rounded-lg bg-brand.blue text-white px-6 py-3">Login</button>
        </form>
      </div>
    </>
  );
}
